// extracted by mini-css-extract-plugin
export default {"mobileMenuButton":"Header_mobileMenuButton__otGXB","desktopNav":"Header_desktopNav__BVIUH"};